import { useTranslation } from 'react-i18next'

import { Card } from '../../../components/Card/card'

import { GEOFENCE } from '../../../constants/modal.constants'
import { SingleAssetGeofencesType } from '../../../types/geofence.type'

import { Button, SpinnerCircular, Notification } from '@weirgroup/weir-dls'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { AddGeofence } from '../../geofence/add-geofence'
import { TagType } from '../../../types/bucketTypes'
import { ToastDataType } from '../../../types/toast.type'
import { useDarkMode } from '../../../hooks/use-darkmode'
interface Props {
    geofenceData: SingleAssetGeofencesType[]
    tagData: TagType
    refreshList: () => void;
    setIsAssetUpdated: Dispatch<SetStateAction<boolean>>
    isGuest: boolean
}

export const GeofenceTab = (props: Props) => {
    const { geofenceData,
        tagData,
        refreshList,
        setIsAssetUpdated,
        isGuest
    } = props
    const { t } = useTranslation()
    const [showAdd, setShowAdd] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [showList, setShowList] = useState<boolean>(true)
    const [showToast, setShowToast] = useState<boolean>(false)
    const [toastData, setToastData] = useState<any>()
    const [selectedGeofence, setSelectedGeofence] = useState<SingleAssetGeofencesType | null>(null);
    const {darkMode} = useDarkMode();
    useEffect(() => {
        if (geofenceData.length > 0) {
            setShowList(true)
            setIsLoading(false);
        } else {
            setShowList(false)
        }
    }, [geofenceData])
    useEffect(() => {refreshList()},[])
    const editGeofence = (geofenceData: SingleAssetGeofencesType) => {
        setShowAdd(true)
        setSelectedGeofence(geofenceData)
    }

    const renderToast = (data: ToastDataType) => {
        setShowToast(true);
        setToastData(data)
        refreshList();
    }

    useEffect(() => {
        if (showToast) {
            setTimeout(() => setShowToast(false), 5000)
        }
    }, [toastData])

    return (
        <>
            {showList ?
                <div className="geofence" data-testid="geofence">
                    {isLoading ?
                        <div className="spinner">
                            <SpinnerCircular darkMode={darkMode}/>
                            <p>{t("loading")}</p>
                        </div> :
                        <>
                            {showAdd ? (
                                <AddGeofence
                                    darkMode={darkMode}
                                    tagData={tagData}
                                    setShowAdd={setShowAdd}
                                    selectedGeofence={selectedGeofence}
                                    setSelectedGeofence={setSelectedGeofence}
                                    refreshList={refreshList}
                                    setIsAssetUpdated={setIsAssetUpdated}
                                />
                            ) : (
                                <>
                                    <div className="add-btn-container">
                                        <Button
                                            darkMode={darkMode}
                                            label={t('addNew')}
                                            size={'sm'}
                                            variant={'primary'}
                                            onClick={() => {
                                                setShowAdd(true)
                                            }}
                                            disabled={isGuest}
                                        />
                                    </div>
                                    <div data-testid="geofence-card">
                                        {geofenceData.map((data: SingleAssetGeofencesType) => {
                                            return (
                                                <Card
                                                    darkMode={darkMode}
                                                    editHandler={editGeofence}
                                                    type={GEOFENCE}
                                                    geofenceData={data}
                                                    key={data.geofence_id}
                                                    setLoader={setIsLoading}
                                                    renderToastMessage={renderToast}
                                                    setIsAssetUpdated={setIsAssetUpdated}
                                                />
                                            )
                                        })}
                                    </div>
                                </>
                            )}
                        </>
                    }
                </div>
                : <div className="no-geofence">
                    <p className="no-geofence-msg">No Configured Geofences</p>
                    <div className="no-geofence-add-btn">
                        <Button
                            label={t('addNew')}
                            size={'sm'}
                            variant={'primary'}
                            onClick={() => {
                                setShowList(true)
                                setShowAdd(true)
                            }}
                        />
                    </div>
                </div>}
            {showToast ? <div className="toast-container">
                <Notification 
                    title={toastData.variant == "success" ? "Success" : "Fail"}
                    textContent={toastData.message}
                    variant={toastData.variant}
                    onClose={()=>{setShowToast(false)}}
                />
            </div> : <></>}
        </>
    )
}
